import styled, { css } from "styled-components";
import InfoSvg from "core/icons/information/info-comment.svg?react";
import DangerSvg from "core/icons/danger/exclamation-triangle.svg?react";
import LightSvg from "core/icons/light/light.svg?react";
import InfoBlack from "core/icons/information/info-solid-circle-black.svg?react";
import { getMarginStyle, getPaddingStyle } from "core/styles/paddingMarginStyle";
import { InlineBannerProps } from ".";

export type Color =
  | "success"
  | "success-2"
  | "secondary"
  | "secondary-2"
  | "warning"
  | "warning-2"
  | "white"
  | "default"
  | "danger"
  | "primary"
  | string;

const colorSelector = ({ color, textColor }: { color?: Color; textColor?: string }) => {
  let cssStyle;

  switch (color) {
    case "success":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.tertiary.tint4};
        color: ${({ theme }) => theme?.colors?.success.main};
      `;
      break;

    case "success-2":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.success.surface};
        color: ${({ theme }) => theme?.colors?.success.main};
        border: 2px solid ${({ theme }) => theme?.colors?.success.border2};
      `;
      break;
    case "secondary":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.secondary.surface};
        color: ${({ theme }) => theme?.colors?.secondary.shade3};
        border: 1px solid ${({ theme }) => theme?.colors?.secondary.default};
      `;
      break;
    case "secondary-2":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.secondary.surface};
        color: ${({ theme }) => theme?.colors?.secondary.shade4};
        border: 1px solid ${({ theme }) => theme?.colors?.secondary.default};
      `;
      break;
    case "secondary-3":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.secondary.surface};
        color: ${({ theme }) => theme?.colors?.neutral.neutral100};
        border: 1px solid ${({ theme }) => theme?.colors?.secondary.border};
      `;
      break;
    case "warning":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.warningv2.surface};
        color: ${({ theme }) => theme?.colors?.warningv2.main};
        border: 1px solid ${({ theme }) => theme?.colors?.warningv2.border};
      `;
      break;
    case "warning-2":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.neutral.neutral10};
        color: ${({ theme }) => theme?.colors?.warningv2.main};
        border: 1px solid ${({ theme }) => theme?.colors?.warningv2.border};
      `;
      break;
    case "white":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.white};
        color: ${({ theme }) => theme?.colors?.neutral.neutral90};
        border: 1px solid ${({ theme }) => theme?.colors?.neutral.neutral30};
      `;
      break;
    case "default":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.secondary.tint4};
        color: ${({ theme }) => theme?.colors?.neutral.neutral90};
        border: 1px solid ${({ theme }) => theme?.colors?.secondary.default};
      `;
      break;
    case "danger":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.danger.surface};
        border: 1px solid ${({ theme }) => theme?.colors?.danger.default};
        color: ${({ theme }) => theme?.colors?.danger.default};
      `;
      break;
    case "primary":
      cssStyle = css`
        background-color: ${({ theme }) => theme?.colors?.primary.surface};
        border: 1px solid ${({ theme }) => theme?.colors?.primary.default};
        color: ${({ theme }) => theme?.colors?.primary.default};
      `;
      break;
    default:
      cssStyle = css`
        background-color: ${color};
        color: ${({ theme }) => theme?.colors?.neutral.neutral90};
      `;
      break;
  }

  if (textColor) {
    cssStyle = cssStyle.concat(css`
      color: ${textColor};
    `);
  }

  return cssStyle;
};

export const Container = styled.div<InlineBannerProps>`
  display: flex;
  position: relative;
  width: ${({ width }) => width || "100%"};
  align-items: center;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  font-family: ${({ bold }) => (bold ? "Nunito-Sans-Bold" : "Nunito-Sans")};
  font-size: ${({ size }) => `${size || 14}px`};
  gap: ${({ gap }) => `${gap ?? 18}px`};

  ${colorSelector}
  ${getMarginStyle}
  ${getPaddingStyle}
`;

export const InfoIcon = styled(InfoSvg)`
  position: relative;
  width: 24px;
  height: 24px;
  bottom: 1px;
`;

export const InfoBlackIcon = styled(InfoBlack)`
  position: relative;
  width: 24px;
  height: 24px;
  bottom: 1px;
`;

export const DangerIcon = styled(DangerSvg)`
  position: relative;
  width: 24px;
  height: 24px;
  bottom: 1px;
`;

export const LightIcon = styled(LightSvg)`
  position: relative;
  width: 24px;
  height: 24px;
  bottom: 1px;
`;
